
  <div (mousemove)="resetIdle()" [class.expanded]="visible" (onHide)="onHide($event)" class="widget-gallery-container" [ngClass]="{'overviewHidden' : (isMobile() && (scrollDirection$ | async) == scrollDown)}">
    <div class="widget-gallery-content">
      <div>
        <h5 class="widget-gallery-title"><span class="widget-gallery-close-button" (click)="onHide($event)"><i class="fa fa-fw fa-close"></i></span></h5>
        <h5 class="widget-gallery-reset"><span class="widget-gallery-reset-button" (click)="reset($event)">Reset</span></h5>
      </div>

      <section class="widget-gallery-wrapper">

        <div class="scrolling-wrapper scrolling-wrapper-flexbox">

          <div #card class="card" *ngFor="let def of (widgetDefinitions$ | async)" (click)="addWidget(def)">
            <div class="header widget-gallery-header">

              <i class="fa fa-info-circle widget-gallery-tooltip" aria-hidden="true"
               [pTooltip]="def.description" appendTo="body"></i>

              <i [ngClass]="def.galleryIcon"></i>
              <h5 class="title"><span>{{def.name}}</span></h5>
            </div>
          </div>

        </div>

      </section>
    </div>
  </div>
